import { render, staticRenderFns } from "./AttachArchitectEngineer.vue?vue&type=template&id=6a5032ce"
import script from "./AttachArchitectEngineer.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachArchitectEngineer.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports